import { render, staticRenderFns } from "./ReviewFieldsArrivalDate.vue?vue&type=template&id=66b19eca&scoped=true"
import script from "./ReviewFieldsArrivalDate.vue?vue&type=script&lang=ts"
export * from "./ReviewFieldsArrivalDate.vue?vue&type=script&lang=ts"
import style0 from "./ReviewFieldsArrivalDate.vue?vue&type=style&index=0&id=66b19eca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b19eca",
  null
  
)

export default component.exports